import {
    FormControl,
    FormLabel,
    Stack,
    Text,
    VStack,
    Box,
    FormErrorMessage,
} from '@chakra-ui/react';
import { Input } from '@/components/v4';
import { textBoxStyling } from 'components/forms/new/formStyles';
import { useDefinedAttributes } from '../DefinedAttributesContext';
import useDefinedAttributeValidation from './useDefinedAttributeValidation';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { useState } from 'react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import LinkifiedText from './LinkifiedText';

export default function IntAttribute({ attribute, index, error }) {
    const [isHovered, setIsHovered] = useState(false);
    const validation = JSON.parse(attribute.definedAttributeValidationType);
    const { attributesErrors } = useDefinedAttributes();
    const {
        handleAttributeChange,
        handleAttributeError,
        removeAttributeError,
    } = useDefinedAttributeValidation();
    const errorObj = attributesErrors
        ? attributesErrors.find((obj) => obj.id === index)
        : undefined;
    const errorMsg = errorObj ? errorObj.message : error;
    const handleChange = (e) => {
        removeAttributeError(index);
        const value = e.target.value;
        if (
            (parseInt(validation.Minimum) > 0 &&
                parseInt(validation.Maximum) > 0 &&
                parseInt(value) > validation.Maximum) ||
            parseInt(value) < validation.Minimum
        ) {
            handleAttributeError(
                index,
                `Only numeric values between ${validation.Minimum} and ${validation.Maximum} are allowed.`,
            );
        }
        handleAttributeChange(value, index);
    };
    return (
        <FormControl
            isRequired={validation.Required}
            isInvalid={!!errorMsg}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                alignItems="flex-start"
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel
                        sx={{
                            ...formLabelStyling(),
                            paddingTop: 0,
                            whiteSpace: 'normal',
                            overflow: 'visible',
                        }}>
                        {attribute.name}
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        <LinkifiedText
                            text={
                                attribute?.description ||
                                'Enter a value for this attribute.'
                            }
                        />
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Input
                            id={`attribute-${index}`}
                            name={`attributes[${index}].value`}
                            placeholder="Please enter a value"
                            type="number"
                            min={validation?.Minimum}
                            max={validation?.Maximum}
                            value={attribute.value ?? ''}
                            onChange={handleChange}
                            sx={{ ...textBoxStyling, paddingTop: 0 }}
                        />
                        <FormErrorMessage
                            display="flex"
                            sx={{ marginTop: '0 !important', fontSize: '10px' }}
                            justifyContent="flex-end">
                            {errorMsg || ''}
                        </FormErrorMessage>
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label={
                            attribute?.description ||
                            'Enter a value for this attribute.'
                        }
                        ariaLabel="vendor-defined-int-attribute-tip"
                        left="25px"
                        top="10px"
                    />
                )}
            </Stack>
        </FormControl>
    );
}
